import ParentView from '@/components/ParentView'
import Layout from '@/layout'
const asyncPersonnelManagementRoutes = {
  path: '/oa/personnelManagement',
  component: Layout,
  redirect: 'noredirect',
  name: '人员管理',
  funcPerms: 'oa:hr',
  meta: {
    title: '人员管理',
    icon: 'personal',
    affix: false,
    noCache: true
  },
  children: [
    {
      path: 'personnelManagement',
      component: () => import('@/views/oa/personnelManagement/index'),
      funcPerms: 'oa:hr:manager',
      name: 'personnelManagement',
      meta: {
        title: '人员管理',
        icon: 'personal',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'add',
      component: () => import('@/views/oa/personnelManagement/add'),
      funcPerms: 'oa:hr:manager:add',
      name: 'PersonnelManagementAdd',
      hidden: true,
      meta: {
        title: '新增人员信息',
        icon: 'index',
        affix: false,
        noCache: false
      }
    },
    {
      path: 'edit',
      component: () => import('@/views/oa/personnelManagement/add'),
      funcPerms: 'oa:hr:manager:edit',
      name: 'personnelManagementEdit',
      hidden: true,
      meta: {
        title: '编辑人员信息',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'view',
      component: () => import('@/views/oa/personnelManagement/add'),
      funcPerms: 'oa:hr:manager:view',
      name: 'personnelManagementView',
      hidden: true,
      meta: {
        title: '查看人员信息',
        icon: 'index',
        affix: false,
        noCache: true
      }
    }
  ]
}

export default asyncPersonnelManagementRoutes
